import { HOME_COPY } from "@/components/dashboard/home-copy";
import { PageRefusal } from "@/components/ui/box";

/** Compatibility name while the Home pages adopt N01's originless refusal. */
export function DashboardNotice({ state, onRetry, perspective = "learning" }: {
  state: "paused" | "error" | "absent";
  onRetry: () => void;
  perspective?: "teaching" | "learning" | "registrar";
}) {
  if (state === "paused") return null;
  const sentence = state === "error" ? HOME_COPY.homeFailed
    : perspective === "teaching" ? HOME_COPY.noTeachingSeat
    : perspective === "registrar" ? HOME_COPY.noRegistrarSeat
    : HOME_COPY.noLearningSeat;
  return <PageRefusal id="home-unavailable" journey="home" refusal={state === "error"
    ? { reason: "unavailable", home: true, sentence, retry: onRetry }
    : { reason: "forbidden", home: true, sentence }} />;
}
